import {createTheme} from '@mui/material/styles';

const theme = createTheme({
    status: {
      danger: "#777",
    },
});

export default theme;